import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import rolesActions from '../../redux/roles/actions';
import RoleList from '../../components/RoleList';
import SidebarContainer from '../SidebarContainer';
import './Roles.scss';

class Roles extends Component {
  componentDidMount() {
    this.props.actions.resetRole();
    this.props.actions.rolesRequest();
  }

  onEdit = async (roleId) => {
    this.props.actions.roleRequest(roleId);
  };

  render() {
    const { actions, roles } = this.props;
    return (
      <SidebarContainer title="Inventory Role Manager">
        <div className="roles-table">
          <RoleList
            list={roles.roles}
            error={roles.error}
            success={roles.success}
            fetching={roles.fetching}
            onDelete={actions.deleteRoleRequest}
            onEdit={this.onEdit}
          />
        </div>
      </SidebarContainer>
    );
  }
}

Roles.propTypes = {
  roles: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ roles }) => ({ roles });

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...rolesActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Roles);
